module.exports = __webpack_public_path__ + "img/directions2.df7a4b77.png";